<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">CXP Abonos</h5>
        <div class="controls-above-table">
          <div class="col-12">
            <div class="row">
              <div class="col-sm-2">
                <router-link
                  class="btn btn-md btn-success"
                  :to="{ name: 'cxp-abono-nuevo', params: {} }"
                >
                  <i class="fa fa-plus"></i>
                  Nuevo Abono
                </router-link>
                <a class href="#"></a>
                <a
                  v-if="mostrarRefresh"
                  class="btn btn-sm btn-info"
                  @click="refreshData"
                  href="#"
                  >Refresh</a
                >
              </div>
              <div class="col-2">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
              </div>
              <div class="col-2">
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActive"
                  @click="filterData"
                >
                  <option value="">Todos</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                  <option value="E">Impreso</option>
                </select>
              </div>
              <div class="col-2">
                <div class="input-group-append">
                  <select
                    class="form-control form-control-sm rounded bright"
                    v-model="filterCargo"
                    @change="refreshCargo"
                    @click="filterData"
                  >
                    <option value="">Tipo</option>
                    <option v-for="(c, key) in abonos" :value="c.id" :key="key">
                      {{ c.id }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-3">
                <ProveedoresSelectComponent
                  @onChange="filterData()"
                  :current="current"
                  titulo="hide"
                />
              </div>
              <div class="col-1">
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col" class="text-center">No. Documento</th>
                <th scope="col" class="text-center">Fecha</th>
                <th scope="col" class="text-center">Tipo de Abono</th>
                <th scope="col" class="text-center">Monto</th>
                <th scope="col" class="text-center">Proveedor</th>
                <th scope="col" class="text-center">¿Negociable?</th>
                <th scope="col" class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-center">{{ current.documento }}</td>
                <td class="text-center">{{ current.fecha_documento }}</td>
                <td class="text-center">{{ current.tipo_abono_obj.nombre }}</td>
                <td class="text-center">{{ current.valor }}</td>
                <td class="text-center">
                  {{ current.proveedor }} - {{ current.proveedor_obj.nombre }}
                </td>
                <td class="text-center">
                  <div class="text-success" v-if="current.es_negociable">SI</div>
                  <div class="text-danger" v-if="!current.es_negociable">NO</div>
                </td>
                <td class="text-center">{{ current.estado_str }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import AbonoService from "@/services/cxp/AbonoService";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    PaginationComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      filterCargo: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActive: "",
      data: [],
      current: {},
      current: {
        proveedor: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      abonos: "cxpabonos/tipoabono",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      AbonoService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
      });
    }
    this.refreshCargo();
    this.clearFilterData();
  },
  methods: {
    refreshCargo() {
      let self = this;
      self.$store.dispatch("cxpabonos/tipoabono", {
        abonos: "nombre",
        quitar_paginacion: true,
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        proveedor: this.current.poveedor,
        "filter[search]": this.searchtext,
        tipo_abono: this.filterCargo,
        estado: this.filterActive,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        proveedor: this.current.proveedor.codigo,
        "filter[search]": this.searchtext,
        tipo_abono: this.filterCargo,
        estado: this.filterActive,
        estado: this.filterActive,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterCargo = "";
      this.filterActive = "";
      this.current.proveedor = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tipo_abono: this.filterCargo,
        estado: this.filterActive,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      AbonoService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxp-abono-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxp-abono-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
